import {
  formatDealerHealthDate,
  formatDealerHealthRate,
  partnerWhatsappDealerHealthLabel,
} from "../../../utils/partnerWhatsappDealerHealthViewModel";

function HealthBadge({ status, label }) {
  const tone =
    status === "ready"
      ? "green"
      : status === "missing_whatsapp" || status === "invalid_phone" || status === "not_synced"
        ? "red"
        : status === "inactive"
          ? "slate"
          : status === "no_activity"
            ? "blue"
            : "amber";

  return (
    <span className={`partner-whatsapp-badge partner-whatsapp-badge--${tone}`}>
      {label || partnerWhatsappDealerHealthLabel(status)}
    </span>
  );
}

function BoolBadge({ value, trueLabel, falseLabel }) {
  const tone = value === true ? "green" : value === false ? "red" : "slate";
  const label = value === true ? trueLabel : value === false ? falseLabel : "—";
  return <span className={`partner-whatsapp-badge partner-whatsapp-badge--${tone}`}>{label}</span>;
}

export default function PartnerWhatsappDealerHealthTable({ items = [] }) {
  if (!items.length) {
    return null;
  }

  return (
    <div className="partner-health-table-wrap">
      <table className="partner-health-table partner-whatsapp-table">
        <thead>
          <tr>
            <th>Dealer</th>
            <th>City</th>
            <th>Health</th>
            <th>WhatsApp</th>
            <th>Vendor sync</th>
            <th>Lead alerts</th>
            <th>Accept rate</th>
            <th>Reply rate</th>
            <th>Manual outreach</th>
            <th>Failed alerts</th>
            <th>Last activity</th>
            <th>Recommended action</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.dealerId}>
              <td>
                <strong>{item.dealerName || "Dealer"}</strong>
                <div className="partner-health-table__meta">{item.dealerId}</div>
              </td>
              <td>{item.city || "—"}</td>
              <td>
                <HealthBadge status={item.healthStatus} label={item.healthLabel} />
              </td>
              <td>
                <div>{item.whatsapp?.maskedPhone || "—"}</div>
                <div className="partner-health-table__meta">
                  {item.whatsapp?.valid ? "Valid" : item.whatsapp?.present ? "Invalid" : "Missing"}
                </div>
              </td>
              <td>
                <BoolBadge
                  value={item.vendor?.synced}
                  trueLabel="Synced"
                  falseLabel="Not synced"
                />
              </td>
              <td>
                <BoolBadge
                  value={item.vendor?.leadAlertsEnabled}
                  trueLabel="Enabled"
                  falseLabel="Disabled"
                />
              </td>
              <td>{formatDealerHealthRate(item.metrics?.acceptRate)}</td>
              <td>{formatDealerHealthRate(item.metrics?.replyRate)}</td>
              <td>{item.metrics?.manualOutreachCount ?? 0}</td>
              <td>{item.metrics?.failedAlertCount ?? 0}</td>
              <td>{formatDealerHealthDate(item.lastActivityAt)}</td>
              <td>{item.recommendedAction || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
